import Accordion from "../../../../../components-new/ui/Accordion";
import AccordionItem from "../../../../../components-new/ui/Accordion/AccordionItem";
import FileUpload from "../../../../../components-new/general/FileUpload";
import colors from "../../../../../utils/Colors";
import ShieldUserIcon from "../../../../../assets/icons/ShieldUserIcon";
import Translate from "../../../../../components/Translate";
import PeopleIcon from "../../../../../assets/icons/PeopleIcon";
import EditButton from "../../../../../components-new/buttons/actions/EditButton";
import DeleteButton from "../../../../../components-new/buttons/actions/DeleteButton";
import React from "react";
import {updateDepartment} from "../../../../../services/internalGroups/api";
import {GroupRole} from "../../../../../services/internalGroups/constants";
import PlusIcon from "../../../../../assets/icons/PlusIcon";
import BlueButton from "../../../../../components-new/buttons/BlueButton";
import Division from "./Divison";
import ContactAvatar from "../../../../../components-new/general/ContactAvatar";

const DepartmentAccordion = ({
                                 department,
                                 onDeleteClick,
                                 onEditClick,
                                 company,
                                 onUpdateDepartment,
                                 onAddDivisionClick,
                                 onEditDivisionClick,
                                 onDeleteDivisionClick
                             }) => {

    const departmentHead = department.members
        ? department.members.find(member => member.groupRole === GroupRole.DEPARTMENT_HEAD)
        : null;

    const updateThumbnail = (url) => {
        updateDepartment(department.id, company.id, {
            name: department.name,
            description: department.description,
            thumbUrl: url,
            headId: departmentHead ? departmentHead.id : null,
        }).then(response => {
            if (response.success && response.department) {
                onUpdateDepartment(response.department);
            }
        });
    }

    return (
        <Accordion
            style={{
                margin: '10px 0'
            }}
            key={department.id}
        >
            <AccordionItem
                value="1"
                triggerContent={
                    <div style={{
                        display: 'flex',
                        alignItems: 'start',
                        justifyContent: 'space-between',
                        flexGrow: 1
                    }}>
                        <div style={{display: 'flex', alignItems: 'start', gap: '10px', flexWrap: 'wrap'}}>
                            <FileUpload
                                windowSize={55}
                                imgSize={45}
                                progressSize={55}
                                handleChange={(link) => {
                                    updateThumbnail(link)
                                }}
                                handleDelete={(e) => {
                                    e.stopPropagation() // prevents accordion opening
                                    updateThumbnail(null)
                                }}
                                image={department.thumbUrl}
                                style={{
                                    flexShrink: 0,
                                }}
                            />
                            <div style={{textAlign: 'start', padding: '6px 0 0 0', minWidth: 0}}>
                                <div style={{marginBottom: '8px'}}>
                                    <div style={{
                                        fontWeight: 'bold',
                                        fontSize: '16px',
                                        lineHeight: '24px'
                                    }}>
                                        {department.name}
                                    </div>
                                    <p style={{
                                        color: colors.silverBlueDark,
                                        margin: '4px 0 0 0',
                                        whiteSpace: 'pre-line',
                                        overflowWrap: 'anywhere'
                                    }}>
                                        {department.description}
                                    </p>
                                </div>

                                <div className="internal-grouping__head">
                                    <ShieldUserIcon width={24} height={22}
                                                    style={{color: colors.silverBlueDark}} stroke="currentColor"/>
                                    <span className="internal-grouping__meta-label"><Translate text="head"/>:</span>
                                    {departmentHead && (
                                        <span className="internal-grouping__person">
                                            <ContactAvatar contact={departmentHead} size={24}/>
                                            <span>{departmentHead.firstName} {departmentHead.lastName}</span>
                                        </span>
                                    )}
                                </div>

                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px'
                                    }}>
                                    <PeopleIcon width={24} height={22}
                                                style={{color: colors.silverBlueDark}} stroke="currentColor"/>
                                    <p>

                                                                <span style={{color: colors.silverBlueDark}}><Translate
                                                                    text="divisions"/>: </span>
                                        <span
                                            style={{fontWeight: 600}}>{department.divisions ? department.divisions.length : 0}</span>
                                    </p>
                                </div>

                            </div>
                        </div>
                        <div className="department-actions"
                             style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                            <EditButton
                                onClick={onEditClick}
                                variant={'ghost'}
                            />
                            <DeleteButton
                                onClick={onDeleteClick}
                                variant={'ghost'}
                            />
                        </div>
                    </div>
                }
            >
                <div style={{
                    textAlign: 'justify',
                    userSelect: 'text',
                    padding: 'var(--ds-spacing-xl)'
                }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '15px'
                    }}>
                        <h3 style={{fontSize: '18px', fontWeight: 'bold'}}>
                            <Translate text="divisions"/>
                        </h3>
                        <BlueButton
                            variant="soft"
                            onClick={() => onAddDivisionClick(department.id)}
                            height={'36px'}
                            width={'auto'}
                            styles={{padding: '0 10px'}}
                        >
                            <PlusIcon width={14} height={14} stroke="currentColor"/>
                            <span style={{fontSize: '12px'}}>
                                <Translate text={'addDivision'}/>
                            </span>
                        </BlueButton>
                    </div>

                    {department.divisions && department.divisions.length > 0 ? (
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px',
                            paddingRight: department.divisions.length > 4 ? '4px' : '0px',
                            overflowY: 'auto',
                            maxHeight: '400px'
                        }}>
                            {department.divisions.map(division => (
                                <Division
                                    key={division.id}
                                    departmentId={department.id}
                                    division={division}
                                    onEditDivisionClick={onEditDivisionClick}
                                    onDeleteDivisionClick={onDeleteDivisionClick}
                                />
                            ))}
                        </div>
                    ) : (
                        <div style={{textAlign: 'center', color: colors.silverBlueDark, padding: '20px'}}>
                            <Translate text="noDivisionsFound"/>
                        </div>
                    )}
                </div>
            </AccordionItem>
        </Accordion>
    )
}

export default DepartmentAccordion;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/internal-grouping/components/DepartmentAccordion.jsx